import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  ({ palette, spacing, themeName, mlbCustomVariables, breakpoints, typography }) => ({
    title: {
      textAlign: 'center',
      margin: spacing(5, 0),
      ...(themeName === 'dacia' && {
        ...typography.h1,
        fontFamily: mlbCustomVariables.primaryFont,
        textTransform: 'uppercase',
        [breakpoints.up('md')]: {
          flexDirection: 'row'
        }
      })
    },
    subtitle: {
      textAlign: 'center',
      ...(themeName === 'dacia' && {
        fontSize: 22,
        fontFamily: 'Read'
      })
    },
    container: {
      display: ' flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: spacing(0, 0, 2.125),
      [breakpoints.up('md')]: {
        flexDirection: 'row'
      }
    },
    numberText: {
      textAlign: 'center',
      marginTop: spacing(2.5),
      ...(themeName === 'dacia' && {
        fontSize: 16
      }),
      paddingBottom: spacing(2),
      [breakpoints.up('md')]: {
        paddingBottom: spacing(0)
      }
    },
    number: {
      border: `2px solid ${palette.common.black}`,
      borderRadius: '50%',
      width: spacing(7),
      height: spacing(7),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 auto'
    },
    iconWrap: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: spacing(2, 0)
    }
  })
);
